import React, { useState, useContext, useEffect } from "react";
import { TableCell, TableRow } from "@mui/material";
import LayoutCreateOrder from "../../../../common/layout/LayoutCreateOrder";
import FieldText from "./../../../../common/component/form/FieldText";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import Files from "react-files";
import OrderMap from "./OrderMap";
import TableScrollDiv from "../../../../common/component/table/TableScrollDiv";
import useForm from "../../../../common/hooks/useForm";
import useAutoComplete from "../../../../common/hooks/useAutoComplete";
import { path } from "../../../../constants/apiPath";
import FieldAutoComplete from "../../../../common/component/form/FieldAutoComplete";
import { useNavigate, useLocation } from "react-router-dom";
import DocumentSVG from "../../../../svg/svg-body/DocumentSVG";
// import PreviewIcon from "@mui/icons-material/Preview";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import { StoreContext } from "../../../../store";
import DeleteIcon from "@mui/icons-material/Delete";
import instance from "../../../../common/api/interceptor";
import orderObject from "../../../../constants/data/orderCreation";
import NotificationManager from "react-notifications/lib/NotificationManager";

function DocUpload() {
  const documentOrderNumber = useForm();
  const docType = useAutoComplete(path.GET_DOC_TYPE);
  const [files, setFiles] = useState([]);
  const [fileError, setFileError] = useState("");
  const navigate = useNavigate();
  const context = useContext(StoreContext);
  const [edit, setEdit] = useState(false);

  const [docDataList, setDocDataList] = useState([]);

  useEffect(() => {
    const orderJSON = context.orderJSON;

    const arr = [...orderJSON.OrderDocumentsCollection];

    setDocDataList([...arr]);
  }, []);

  const onFilesChange = (files) => {
    setFiles(files);
    if (!documentOrderNumber.value) {
      documentOrderNumber.setValue(files[0]?.name);
    }
    files.length !== 0 && setFileError("");
  };
  const onfileRemove = () => {
    documentOrderNumber.setValue("");
    setFiles([]);
  };
  const onDocUpload = async () => {
    documentOrderNumber.setValue("");
    if (files.length && docType.value) {
      const getBase64 = async (file, onLoadCallback) => {
        return await new Promise(function (resolve, reject) {
          var reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      let DocsFileConversion = "";
      var promise = getBase64(files[0]);
      promise.then((result) => {
        DocsFileConversion = `${result.split(";base64,")[0]};base64,`;
        let data = result.split(";base64,")[1];
        let filesizeUnit = files[0].sizeReadable.substr(-2);
        let fileSize = files[0].sizeReadable.split(
          files[0].sizeReadable.substr(-2)
        )[0];
        setDocDataList([
          ...docDataList,
          {
            DocsPk: "",
            DocsFk: "",
            DocsDocType: docType.value.Code,
            docTypeDesc: docType.value.Description,
            DocsFileName: documentOrderNumber.value
              ? documentOrderNumber.value
              : files[0].name,
            DocsFileSize: fileSize,
            DocsFileSizeUnit: filesizeUnit,
            DocsUploadedDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            DocsUploadedBY: context.userData.FullName ?? "",
            DocsFileData: data,
            DocsFileExtention: files[0].extension,
            DocsFileConversion: DocsFileConversion,
          },
        ]);
      });
    }
    setFiles([]);
  };
  const onFilesError = (error, file) => {
    NotificationManager.error(error.message, "", 3000);
    setFileError(`Error code ${error.code} : ${error.message}.`);
  };
  const column = [
    "Sr. No",
    "Doc Type",
    "Doc Name",
    "Doc Size",
    "Uploaded On",
    "Uploaded By",
    "Download",
    "Delete",
  ];

  const onNextHandler = (path) => {
    const arr = [...docDataList];
    const body = {
      ...context.orderJSON,
      OrderDocumentsCollection: [...arr],
      OrderNotesCollection: [],
    };
    context.setOrderJSON({
      ...body,
    });
    navigate(path, {
      state: { edit: edit },
    });
  };

  // const onPostOrder = (route, body) => {
  //   // alert("api");
  //   instance
  //     .post(path.POST_ORDER, body)
  //     .then((res) => {
  //       navigate(route);
  //       // console.log(res);
  //     })
  //     .catch((err) => {});
  // };

  return (
    <LayoutCreateOrder onNextHandler={onNextHandler} title="Create Order">
      <div className="_orderDocUpload">
        <div className="container-fluid">
          <div className="row">
            <div className=" col-12 _orderDocDetails">
              <div className="row">
                <div className="col-md-4 col-12 _orderUploadDoc">
                  <h5>Upload E-Docs</h5>
                  <FieldAutoComplete
                    label="Document Type"
                    item="Description"
                    value={docType.value}
                    onChange={docType.onChange}
                    error={docType.error}
                    errorMsg={docType.errorMsg}
                    options={docType.options}
                  />
                  <FieldText
                    label="Document Name"
                    value={documentOrderNumber.value}
                    onChange={documentOrderNumber.onChange}
                    error={documentOrderNumber.error}
                    errorMsg={documentOrderNumber.errorMsg}
                  />
                  {files.length === 0 ? (
                    <Files
                      className="files-dropzone"
                      dragActiveClassName="files-dropzone-active"
                      onChange={onFilesChange}
                      onError={onFilesError}
                      accepts={[".pdf", ".docx", ".xlsx", ".xls", ".csv"]}
                      maxFileSize={1024000}
                      minFileSize={0}
                      clickable
                      multiple={false}
                    >
                      <CloudUploadOutlinedIcon />
                      <p>Drag and Drop Docs Here</p>
                      <span>or</span>
                      <p>Click here to browse Docs</p>
                      <p className="_filemaxInfo">
                        Max. File size should be less than 1MB
                      </p>
                    </Files>
                  ) : (
                    <div>
                      <div className="files-dropzone">
                        <div className="_documentShow">
                          {files.map((items) => {
                            return (
                              <div
                                className={`_uploadDoc ${items.id}`}
                                key={items.id}
                              >
                                <DocumentSVG colorCode={"#438bc3"} />
                                <p title={items.name}>{items.name}</p>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row justify-content-between my-2">
                    <div className="_outlineButton w-auto">
                      <button className="_outlineButton" onClick={onfileRemove}>
                        Cancel
                      </button>
                    </div>
                    <div className="_solidButton w-auto">
                      <button className="_solidButton" onClick={onDocUpload}>
                        Upload
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-12 _orderDocList">
                  <h5>Document List</h5>
                  <TableScrollDiv className="_orderLineTable" column={column}>
                    {docDataList.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={column.length}>
                          No Doc Uploaded
                        </TableCell>
                      </TableRow>
                    ) : (
                      docDataList.map((ele, index) => {
                        return (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{ele.DocsDocType}</TableCell>
                            <TableCell>{ele.DocsFileName}</TableCell>
                            <TableCell>{`${ele.DocsFileSize} ${ele.DocsFileSizeUnit}`}</TableCell>
                            <TableCell>
                              {ele.DocsUploadedDate.split(" ")[0]}
                            </TableCell>
                            <TableCell>{ele.DocsUploadedBY}</TableCell>
                            <TableCell>
                              <a
                                className="_orderlineDocDownloadAnchor"
                                href={`${ele.DocsFileConversion}${ele.DocsFileData}`}
                                target={"_blank"}
                                download={ele.DocsFileName}
                                name={ele.DocsFileName}
                              >
                                <DownloadIcon />
                              </a>
                            </TableCell>
                            <TableCell>
                              <button
                                className="_orderLineDeleteRow"
                                onClick={() => {
                                  let arr = docDataList;
                                  let filtered = arr.filter(function (
                                    value,
                                    index,
                                    arr
                                  ) {
                                    return value !== ele;
                                  });
                                  setDocDataList([...filtered]);
                                }}
                              >
                                <DeleteIcon />
                              </button>
                            </TableCell>
                          </TableRow>
                        );
                      })
                    )}
                  </TableScrollDiv>
                  {/* <iframe src={docDataList[1]?.fileBase64}></iframe> */}
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 col-12 _orderPlanMap">
              <OrderMap />
            </div> */}
          </div>
        </div>
      </div>
    </LayoutCreateOrder>
  );
}

export default DocUpload;
